import { useNavigate, useHistory } from "react-router-dom"
import DelayedLinkWithFadeout from "../utils/DelayedLinkWithFadeout"

export default function VoltarBtn({rota}) {
    const navigate = useNavigate()
    return(
        <DelayedLinkWithFadeout to={rota}>
            <button className="flex items-center px-8 py-3">
                <img src="/arrow.svg" alt="" srcset="" className="rotate-180 text-primary-600 object-fill"/>
                <span className="font-semibold text-primary-600 text-3xl">Voltar</span>
            </button>
        </DelayedLinkWithFadeout>
    )
}